<template>
  <a-layout>
    <a-layout-content :style="{ margin: '24px 16px 0', overflow: 'initial' }">
      <a-row :gutter="[16,16]">
        <a-col :span="7">
          <a-card>
            <div class="vd-card-avatar-center">
              <a-avatar class="vd-card-avatar" :size="96" :src="defaultAvatar" icon="user"/>
              <p>{{userInfo.nickname}}</p>

            </div>
            <a-divider :dashed="true"/>
            <p>登陆次数：{{userInfo.login_total}}</p>
            <p>最近登陆：{{$FormatUtil.timestamp2date(userInfo.login_time)}}</p>
            <a-divider :dashed="true"/>
          </a-card>
        </a-col>
        <a-col :span="17">
          <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" :tab="'小程序（'+count+'）'">

              <a-table :data-source="list"
                       style="background-color: white"
                       :defaultExpandAllRows="true"
                       :pagination="pagination"
                       @change="pageChange"
                       row-key="id"
                       :scroll="{ x: 900 }"
                       size="small">
                <a-table-column title="活动编号" fixed="left" data-index="activity_id"/>
                <a-table-column title="活动名称" fixed="left" data-index="a_name"/>
                <a-table-column title="活动状态" fixed="left" data-index="a_status">
                  <template slot-scope="text">
                    <template v-if="text === 1 ">
                      <a-tag color="green">推广中</a-tag>
                    </template>
                  </template>
                </a-table-column>
                <a-table-column title="推广页面" data-index="p_path_img">
                  <template slot-scope="text">
                    <a-tooltip>
                      <template slot="title">
                        <img :src="$CheckUtil.CheckEmpty(text) ? text :''" alt="二维码" style="width: 160px"/>
                      </template>
                      <a-avatar :src="$CheckUtil.CheckEmpty(text) ? text :''" shape="square" :size="84">二维码
                      </a-avatar>
                    </a-tooltip>
                  </template>
                </a-table-column>
                <a-table-column title="推广二维码" data-index="qrcode">
                  <template slot-scope="text">
                    <a-tooltip>
                      <template slot="title">
                        <img :src="$CheckUtil.CheckEmpty(text) ? text :''" alt="二维码" style="width: 160px"/>
                      </template>
                      <a-avatar :src="$CheckUtil.CheckEmpty(text) ? text :''" shape="square" :size="84">二维码
                      </a-avatar>
                    </a-tooltip>
                  </template>
                </a-table-column>
                <a-table-column align="center" title="完成度">
                  <template slot-scope="record">
                    {{record.complete}} / {{record.task}}
                  </template>
                </a-table-column>
                <a-table-column align="center" fixed="right" title="操作">
                  <template slot-scope="record">
                    <a-tag @click="downloadGif(record.qrcode,record.a_name + '-' +record.name+'-Qr')">
                      <a-icon type="download"></a-icon>
                    </a-tag>
                  </template>
                </a-table-column>
              </a-table>

            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
  import { myJoinActivityList } from '@/api'
  import defaultAvatar from '@/assets/default.jpg'

  export default {
    name: 'Base',
    data () {
      return {
        defaultAvatar,
        userInfo: {},
        myActivity: [
          { name: '测试' },
        ],
        pagination: {
          current: 1,
          pageSize: 5,
          total: 20,
        },
        list: [],
        count: 0,
      }
    },
    created () {
      this.userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
      this.getData()
    },
    mounted () { },
    methods: {
      getData () {
        myJoinActivityList('program', this.pagination.current, this.pagination.pageSize).then(res => {
          if (res['code'] === 1) {
            this.list = res['list']
            this.count = res['count']
            this.pagination.total = res['count']
          }
        })
      },
      callback (e) {
        console.log(e)
      },
      downloadGif (url, activity_name) {
        let img = new Image()
        img.setAttribute('crossOrigin', 'Anonymous')
        img.onload = function () {
          let canvas = document.createElement('canvas')
          let context = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height
          context.drawImage(img, 0, 0, img.width, img.height)
          let url = canvas.toDataURL('images/png')
          let a = document.createElement('a')
          let event = new MouseEvent('click')
          a.download = activity_name + '.png'
          a.href = url
          a.dispatchEvent(event)
        }
        img.src = url
      },
      pageChange (e) {
        this.pagination.current = e.current
        this.getData()
      },
    },

  }
</script>

<style scoped>

</style>